import { render, staticRenderFns } from "./connection-list.vue?vue&type=template&id=83d2ce2a&scoped=true&"
import script from "./connection-list.vue?vue&type=script&lang=ts&"
export * from "./connection-list.vue?vue&type=script&lang=ts&"
import style0 from "./connection-list.vue?vue&type=style&index=0&id=83d2ce2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d2ce2a",
  null
  
)

export default component.exports